import { render, staticRenderFns } from "./StoreManage.vue?vue&type=template&id=651f9fb2&scoped=true&"
import script from "./StoreManage.vue?vue&type=script&lang=js&"
export * from "./StoreManage.vue?vue&type=script&lang=js&"
import style0 from "./StoreManage.vue?vue&type=style&index=0&id=651f9fb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651f9fb2",
  null
  
)

export default component.exports